export type BlogLocale = 'ru' | 'en'

export const BLOG_LOCALES: readonly BlogLocale[] = ['ru', 'en']
export const DEFAULT_BLOG_LOCALE: BlogLocale = 'ru'

export interface LocalizedBlogPost {
  locale: BlogLocale
}

export function isBlogLocale(value: string | null | undefined): value is BlogLocale {
  return value === 'ru' || value === 'en'
}

export function readStoredBlogLocale(storageKey: string): BlogLocale | null {
  if (typeof window === 'undefined') return null
  try {
    const value = window.localStorage.getItem(storageKey)
    return isBlogLocale(value) ? value : null
  } catch {
    return null
  }
}

export function writeStoredBlogLocale(storageKey: string, locale: BlogLocale): void {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(storageKey, locale)
  } catch {
    // Storage may be blocked, but the in-memory UI state can still update.
  }
}

export function filterPostsByLocale<T extends LocalizedBlogPost>(
  posts: readonly T[],
  locale: BlogLocale,
): T[] {
  return posts.filter((post) => post.locale === locale)
}
